export interface AdminRuntimeConfig {
  apiBaseUrl: string;
  clerkPublishableKey: string;
}

interface RuntimeConfigInput {
  runtime?: Partial<AdminRuntimeConfig>;
  fallback?: Partial<AdminRuntimeConfig>;
  isDevelopment: boolean;
  workerError?: string;
}

interface ResolvedRuntimeConfig extends AdminRuntimeConfig {
  error?: string;
}

function clean(value?: string): string {
  return value?.trim() ?? '';
}

function normalizeApiUrl(value?: string): string {
  return clean(value).replace(/\/+$/, '');
}

export function resolveRuntimeConfig(input: RuntimeConfigInput): ResolvedRuntimeConfig {
  const fallback = input.isDevelopment ? input.fallback : undefined;
  const apiBaseUrl = normalizeApiUrl(input.runtime?.apiBaseUrl)
    || normalizeApiUrl(fallback?.apiBaseUrl);
  const clerkPublishableKey = clean(input.runtime?.clerkPublishableKey)
    || clean(fallback?.clerkPublishableKey);
  const missing = [
    !apiBaseUrl && 'API_BASE_URL',
    !clerkPublishableKey && 'CLERK_PUBLISHABLE_KEY',
  ].filter(Boolean);

  return {
    apiBaseUrl,
    clerkPublishableKey,
    error: clean(input.workerError)
      || (missing.length ? `Missing required admin settings: ${missing.join(', ')}.` : undefined),
  };
}

const runtimeValues = typeof window === 'undefined'
  ? undefined
  : window.__RESIDENONE_CONFIG__;
const workerError = typeof window === 'undefined'
  ? undefined
  : window.__RESIDENONE_CONFIG_ERROR__;

const resolved = resolveRuntimeConfig({
  runtime: runtimeValues,
  fallback: {
    apiBaseUrl: import.meta.env.VITE_API_URL,
    clerkPublishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
  },
  isDevelopment: import.meta.env.DEV,
  workerError,
});

export const apiBaseUrl = resolved.apiBaseUrl;
export const clerkPublishableKey = resolved.clerkPublishableKey;
export const runtimeConfigError = resolved.error;
